module.exports = __webpack_public_path__ + "static/media/Illus-PlateFull@3x.44177c73.png";